import React, { useRef, useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { authUpload } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { ADMIN_FIELD, BTN_OUTLINE, mediaSrc } from "../../config/brand";
import { toast } from "sonner";

export default function ImageUploadField({
  label,
  hint,
  kind,
  value,
  onChange,
  onUploaded,
  previewClassName,
  previewAlt,
}) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const pick = () => inputRef.current?.click();

  const onFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const res = await authUpload("/api/admin/uploads", file, { kind });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        toast.error(data.detail || "Upload impossible");
        return;
      }
      if (onUploaded) onUploaded(data.url);
      else onChange(data.url);
    } catch {
      toast.error("Erreur réseau");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <Label className="text-slate-700">{label}</Label>
      <div className="mt-1 flex flex-wrap items-center gap-3">
        {value ? (
          <img
            src={mediaSrc(value)}
            alt={previewAlt}
            className={previewClassName}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : null}
        <div className="space-y-2 min-w-[12rem] flex-1">
          <input
            ref={inputRef}
            type="file"
            accept="image/png,image/jpeg,image/webp"
            className="sr-only"
            onChange={onFile}
          />
          <Button type="button" className={BTN_OUTLINE} disabled={uploading} onClick={pick}>
            {uploading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-2" />
                Import…
              </>
            ) : (
              <>
                <Upload className="h-4 w-4 mr-2" />
                {value ? "Remplacer" : "Importer"}
              </>
            )}
          </Button>
          <Input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="/images/… ou https://…"
            className={ADMIN_FIELD}
          />
        </div>
      </div>
      {hint ? <p className="text-slate-500 text-xs mt-1">{hint}</p> : null}
    </div>
  );
}
